import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaLightbulb, FaPencilRuler, FaCode, FaRocket } from 'react-icons/fa';
import './Process.css';
import { Link } from 'react-router-dom';

const Process = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const steps = [
    {
      number: '01',
      icon: FaLightbulb,
      title: 'Discovery & Planning',
      description: 'We start by understanding your vision, goals, and requirements. Our team conducts thorough research and creates a detailed project roadmap.',
      color: '#6366f1'
    },
    {
      number: '02',
      icon: FaPencilRuler,
      title: 'Design & Prototype',
      description: 'Our designers craft intuitive interfaces and interactive prototypes, ensuring the perfect user experience before development begins.',
      color: '#8b5cf6'
    },
    {
      number: '03',
      icon: FaCode,
      title: 'Development & Testing',
      description: 'Expert developers bring designs to life using cutting-edge technologies, with rigorous testing at every stage to ensure quality.',
      color: '#ec4899'
    },
    {
      number: '04',
      icon: FaRocket,
      title: 'Launch & Support',
      description: 'We handle the deployment and provide ongoing support, ensuring your solution runs smoothly and continues to evolve with your needs.',
      color: '#10b981'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.6 }
    }
  };

  return (
    <section className="process" id="process" ref={ref}>
      <div className="process-container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <span className="section-tag">Our Process</span>
          <h2 className="section-title">How We Work</h2>
          <p className="section-description">
            A proven methodology that delivers exceptional results
          </p>
        </motion.div>

        <motion.div
          className="process-timeline"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="process-step"
              variants={itemVariants}
            >
              <motion.div
                className="step-number"
                style={{ background: step.color }}
                whileHover={{ scale: 1.1, rotate: 5 }}
              >
                {step.number}
              </motion.div>

              <div className="step-content">
                <motion.div
                  className="step-icon"
                  style={{ color: step.color }}
                  whileHover={{ scale: 1.1, rotate: -5 }}
                >
                  <step.icon />
                </motion.div>

                <h3>{step.title}</h3>
                <p>{step.description}</p>

                {index < steps.length - 1 && (
                  <div className="step-connector"></div>
                )}
              </div>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          className="process-cta"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 1 }}
        >
          <div className="cta-content">
            <h3>Ready to start your project?</h3>
            <p>Let's bring your ideas to life with our proven process</p>
          </div>
                    <Link to="/contact">
          
          <motion.button
            className="cta-btn"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Get Started Now
          </motion.button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default Process;
